import { render, staticRenderFns } from "./LockOverlay.vue?vue&type=template&id=590d1e6e&scoped=true"
import script from "./LockOverlay.vue?vue&type=script&lang=js"
export * from "./LockOverlay.vue?vue&type=script&lang=js"
import style0 from "./LockOverlay.vue?vue&type=style&index=0&id=590d1e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d1e6e",
  null
  
)

export default component.exports